import LeaveTypeComponent from "components/Settings/LeaveType";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { mapStateToProps } from "store/helpers/mapState";

function LeaveSettings({  SetSelectedMenu }) {

   

    useEffect(() => {
        SetSelectedMenu({
            menu: "leave/settings",
            title: "Leave Type Settings"
        })
    }, []);





    return <LeaveTypeComponent />
}

export default connect(mapStateToProps, mapDispatchToProps)(LeaveSettings);